import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemperatureUnitService {

  private unitSubject = new BehaviorSubject<'C' | 'F'>('F');

  currentUnit$ = this.unitSubject.asObservable();

  getCurrentUnit(): 'C' | 'F' {
    return this.unitSubject.value;
  }

  setUnit(unit: 'C' | 'F') {
    this.unitSubject.next(unit);
  }

  setUnitFromProfileValue(temperatureUnit: string): void {
    const unit: 'C' | 'F' = temperatureUnit === 'Celsius' ? 'C' : 'F';
    this.unitSubject.next(unit);
  }

}